module.exports = __webpack_public_path__ + "static/media/glasses-alt.bed77b4c.svg";